// Interface strings.

// interface strings; the language choice is remembered per browser
export const I18N = {
  es: {
    day: 'Día',
    night: 'Noche',
    reset: '↺ Reiniciar',
    resetTitle: 'Volver al inicio (R)',
    fullscreen: 'Pantalla completa (F)',
    exitFullscreen: 'Salir de pantalla completa (F)',
    hint: 'Un paseo en moto por mi trayectoria',
    introSub: '7 paradas · WASD o flechas para conducir · E para ver cada capítulo',
    ride: 'WASD / flechas para conducir · Shift turbo · Espacio frena · rueda zoom · C vista general',
    orbit: 'Arrastra para girar · rueda para acercar',
    chapter: 'Capítulo',
    chapters: 'Capítulos',
    done: '¡Has completado el recorrido! Gracias por el paseo. ',
    close: 'Pulsa <b>E</b> o <b>Esc</b> para seguir conduciendo.',
    other: 'EN',
    otherTitle: 'English',
    lockedFirst: 'Bloqueado. Primero ve a la parada',
    mapHide: 'Ocultar mapa (M)',
    mapShow: 'Mostrar mapa (M)',
    resetQ: '¿Cómo quieres reiniciar?',
    resetKeep: 'Mantener capítulos vistos',
    resetFresh: 'Empezar de cero',
    resetCancel: 'Cancelar',
    backToBike: '🛵 Volver a la moto',
    traffic: '🚗 Tráfico',
    traffic_low: 'bajo',
    traffic_mid: 'medio',
    traffic_high: 'alto',
    introSubTouch: '7 paradas · joystick para conducir · toca el aviso para abrir cada capítulo',
    closeTouch: 'Toca × para seguir conduciendo.',
  },
  en: {
    day: 'Day',
    night: 'Night',
    reset: '↺ Restart',
    resetTitle: 'Back to the start (R)',
    fullscreen: 'Full screen (F)',
    exitFullscreen: 'Exit full screen (F)',
    hint: 'A scooter ride through my career',
    introSub: '7 stops · WASD or arrow keys to ride · E to open each chapter',
    ride: 'WASD / arrows to ride · Shift boost · Space brakes · wheel zoom · C overview · M map',
    orbit: 'Drag to rotate · wheel to zoom',
    chapter: 'Chapter',
    chapters: 'Chapters',
    done: 'You finished the ride! Thanks for coming along. ',
    close: 'Press <b>E</b> or <b>Esc</b> to keep riding.',
    other: 'ES',
    otherTitle: 'Español',
    lockedFirst: 'Locked. First go to stop',
    mapHide: 'Hide map (M)',
    mapShow: 'Show map (M)',
    resetQ: 'How do you want to restart?',
    resetKeep: 'Keep chapters seen',
    resetFresh: 'Start from scratch',
    resetCancel: 'Cancel',
    backToBike: '🛵 Back to the bike',
    traffic: '🚗 Traffic',
    traffic_low: 'light',
    traffic_mid: 'normal',
    traffic_high: 'heavy',
    introSubTouch: '7 stops · joystick to ride · tap the prompt to open each chapter',
    closeTouch: 'Tap × to keep riding.',
  },
};
